<template>
  <div class="social-date-picker">
    <fieldset class="date-time">
      <div class="date">

      	<span v-show="!editing" class="vdp-datepicker exclude-outside-click field-value text-hover-bg" @click="editing=true"  @keyup="onWrapperKeyUp" tabindex="0">
      	  <span
      	    class="exclude-outside-click vdp-datepicker__placeholder"
      	    v-if="postDate"
      	  v-html="displayPostDate(postDate)"></span>
      	  <span class="not-set exclude-outside-click  vdp-datepicker__placeholder" v-else>No Date</span>
      	</span>

        <div v-show="editing" class="custom-field date-pick-field" @keyup.stop="onKeyUp">

        			      <DatePicker
        			        placeholder="No Date"
        			        v-model="postDate"
                      v-click-outside="outside"
          						:highlighted="highlightedDates"
          						:format="displayPostDate"
        			        :inline="true"
        			        calendar-class="test-date-calendar"
        			        ref="customDatepicker"
        			        tabindex="0"
        			        :autofocus="true"
        			        @changedMonth="calendarChangedMonth"
                      @closed="dateTimeUpdated" 
                      @input="dateTimeUpdated" 
        			        @selected="setDefaultTime" 
        			      >
        				    <div slot="beforeCalendarHeader" class="calender-header">
        				      <b-button class="remove-dl-btn" variant="text" @click="resetDeadline">Remove Deadline</b-button>
        				      <b-button class="today-btn" variant="text" @click="onToday">Today</b-button>
        				    </div>
        			      <div slot="calendarFooter" class="calender-footer">
        								<div class="time-wrapper">
        			       			      <input type="time" :id="timePickerId"  name="appt"
                                 step="60"
        			       			  	v-model="postTime"
        			       			  	:disabled="inputsDisabled"
        			       			  	ref="refTime"
        			       			  	tabindex="1"
        											@keyup.escape.stop="onKeyUp"
                              @blur="dateTimeUpdated"
        			       			  	/>
        			       			  </div>
        			      		<b-button class="today-btn" variant="text" @click="onDone" tabindex="2">Done</b-button>
          					</div>


        			       </DatePicker>
        			     </div>

        <i v-if="isDateDuplicate" class="fas fa-exclamation-circle date-duplicate-icon" :id="duplicateDateTooltipId"></i>
        <b-tooltip v-if="isDateDuplicate" :target="duplicateDateTooltipId" triggers="hover">
          This date has multiple posts scheduled
        </b-tooltip>
      </div>
      <div class="time">

      	<input type="time" :id="timePickerId"  name="appt"
      	v-model="postTime"
        step="60"
      	:disabled="dateTimeDisabled"
      	@blur="dateTimeUpdated"
      	/>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from '../vue-datepicker/Datepicker.js'
import '../vue-datepicker/Datepicker.css'

export default {
  data() {
    return {

    		componentId: ""+Math.random() + "-" + Math.random(),

    	  timeFormat: "HH:mm",
    	  dateArray: [],
    	  currentYear: null,
    	  currentMonth: null,
    	  inputsDisabled: false,

      postDate: "",
      postTime: "",
      dateTimeDisabled: false,
      dateFormatUI: "YYYY-MM-DD HH:mm",
      dateFormatDB: "YYYY-MM-DD HH:mm:ss",
      editing:false,
      dateSelected:false,
    }
  },
  components: {
    DatePicker,
  },
  props: ["deliverableId", "publishDate", "seriesId", "latestPost", "seriesDeliverables", "namespace"],
  computed: {
  		...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  deliverableDetail (state, getters) {
  	    return getters[this.namespace + 'deliverableDetail']
  	  },
  	  systemSettings (state, getters) {
  	    return getters['systemSettings']
  	  },
  	}),
    postDateFormatted(){
      return this.$moment(this.postDate).format("YYYY-MM-DD");
    },
    dateIsSet(){
        return true;
    },
    timeIsSet(){
        return true;
    },
    highlightedDates(){
      if(this.seriesDeliverables !== undefined){
        let that = this;
        let dates = [];
        this.seriesDeliverables.forEach(function(deliverable){
          if(deliverable.publish_date !== null){
            dates.push(
              that.$moment.utc(deliverable.publish_date).local().toDate()
            )
          }
        });
        return {dates};
      }
      return {};
    },
    timePickerId(){
      if(this.deliverableId){
        return "social-post-time-"+this.deliverableId;
      }
      return "social-post-time-new-date";
    },
    isDateDuplicate(){
      let isDuplicate = false;
      if(this.seriesDeliverables){
        let that = this;
        let publishDate = this.$moment.utc(this.publishDate).local();
        for(let post of this.seriesDeliverables){
          if(that.deliverableId == post.id){
            continue;
          } else if(post.publish_date == null){
            continue;
          }
          let seriesPublishDate = that.$moment.utc(post.publish_date).local();
          if(publishDate.isSame(seriesPublishDate, 'day')){
            isDuplicate = true;
          }
        }
      }
      return isDuplicate;
    },
    duplicateDateTooltipId(){
      return "duplicate-date-"+this.deliverableId;
    }
  },
  methods: {
		onWrapperKeyUp(e) {
			if (e.keyCode === 13) {
				// this.findPosition();
			  this.editing = true;
			}
		},
		onDone() {
			this.editing = false
		  this.dateSelected = true
		  this.clickSaveDate();
		},
		onToday() {
		  this.postDate = this.$moment().format("YYYY-MM-DD");
		  this.postTime = this.$moment().format("H:m");
		  this.editing = false
		  this.dateSelected = true
		  this.clickSaveDate();
		},
		resetDeadline() {
			this.postDate = null;
			this.postTime = null;
		  this.editing = false
		  this.dateSelected = true
		  this.clickSaveDate();
		},
    setDefaultTime() {
      // when a date is selected, set time to midnight by default
      // so when clicking on date & only hour will set post time
      if (this.postDate && !this.postTime) {
        this.postTime = "00:00:00"
      }
    },
		clickSaveDate(){
		  if(this.dateIsSet && this.timeIsSet){
		    this.dispatchPublishDate();
		  }
		},

      onKeyUp(e) {
      	if (e.keyCode === 27) {
      	  this.editing = false;
      	  this.dateSelected = false;
      	}
      	if (e.keyCode === 13) {
      	  this.editing = false;
      	  this.dateSelected = true;
      	  this.clickSaveDate();
      	   e.stopPropagation();
      	}
      },
    outside() {
      this.editing = false;
      this.dateSelected = false;
    },
  	calendarChangedMonth(month){
  	  let date = null;
  	  if(month instanceof Date){
  	    date = this.$moment(month);
  	  } else {
  	    date = this.$moment(month.timestamp);
  	  }
  	  this.currentMonth = date.format("MM");
  	  this.currentYear = date.format("YYYY");
  	},
    dateTimeUpdated(){
      if(this.dateIsSet && this.timeIsSet){
        this.dispatchPublishDate();
      }
      else if(this.dateIsSet && !this.timeIsSet){
        let currentDateTime = this.$moment().startOf('minute');
        let nine = this.$moment("09:00", "HH:mm");
        let midnight = this.$moment().startOf('day');
        let selectedDate = this.$moment(this.postDate).startOf('day');
        if(midnight.isSame(selectedDate)){
          if(currentDateTime.isBetween(midnight, nine)){
            this.postTime = "00:00"
            this.dispatchPublishDate();
          } else {
            let remainder = 15 - (currentDateTime.minute() % 15);
            this.postTime = this.$moment(currentDateTime).add(remainder, "minutes").add(2, "hours").format("HH:mm");
            this.dispatchPublishDate();
          }
        } else {
          this.postTime = "00:00"
          this.dispatchPublishDate();
        }
      }
      
    },
    dispatchPublishDate(){
      let that = this;

      if (that.postTime == "" || that.postTime == null) {
      	that.postTime = "00:00";
      }
      let selection = this.postDateFormatted+" "+this.postTime;
      let utc = this.$moment(selection).utc().format(this.dateFormatDB);
      if (that.postDate == null) {
      		utc = null;
      }
      if(utc == "Invalid date"){
        return;
      }
      this.dateTimeDisabled = true;
      if(this.seriesId !== undefined && this.deliverableId === undefined){
        // New Series Post
        let returnId = this.deliverableDetail.id;
        this.$store.dispatch(this.namespace + "updateDeliverablePublishDate", {
          social_series_id: that.seriesId,
          return_id: returnId,
          value: utc
        }).then(function(){
          that.postDate = "";
          that.postTime = "";
          that.dateTimeDisabled = false;
        	that.$root.$emit('deliverable::updatedPublishDate');

        });
      } else {
        // Regular Post
        let returnId = this.deliverableDetail.id;
        this.$store.dispatch(this.namespace + "updateDeliverablePublishDate", {
          id: that.deliverableId,
          return_id: returnId,
          value: utc
        }).then(function(){
          that.dateTimeDisabled = false;
        	that.$root.$emit('deliverable::updatedPublishDate');

        });
      }
    },
    displayPostDate(date){
      let today = this.$moment();
      if(today.isSame(this.postDate, 'day')){
        return "Today";
      }
      return this.$moment(date).format("ddd, MMM D YYYY");
    },
  },
  created(){
    if(this.publishDate != null){
      let localPublishDate = this.$moment.utc(this.publishDate).local().format(this.dateFormatUI);
      if(localPublishDate != "Invalid date"){
        let localPublishArray = localPublishDate.split(" ");
        this.postDate = this.$moment(localPublishArray[0]).toDate();
        this.postTime = localPublishArray[1];
      }
    } else {
      if(this.latestPost != undefined){
        let localPublishDate = this.$moment.utc(this.latestPost.publish_date).local().format(this.dateFormatUI);
        if(localPublishDate != "Invalid date"){
          let localPublishArray = localPublishDate.split(" ");
          this.postTime = localPublishArray[1];
        }
      }
    }
  }

}
</script>